var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1037_22864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0877 19.0437H36.1877V13.3312H34.2877V19.0437H30.4752V20.9562H28.5752V24.7562H30.4752V26.6687H34.2877V34.2812H36.1877V26.6687H38.0877V24.7562H40.0002V20.9562H38.0877V19.0437ZM34.2877 22.8562H32.3752V20.9562H34.2877V22.8562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.287 34.2812H32.3745V36.1937H34.287V34.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.287 11.4312H32.3745V13.3312H34.287V11.4312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.375 36.1937H3.8125V38.0937H32.375V36.1937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5747 3.80624H24.7622V5.71874H28.5747V3.80624Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7622 5.71871H20.9497V7.61871H24.7622V5.71871Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9503 3.80624H19.0503V5.71874H20.9503V3.80624Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0503 1.90619H15.2378V3.80619H19.0503V1.90619Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2373 3.80624H11.4248V5.71874H15.2373V3.80624Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4248 5.71871H7.6123V7.61871H11.4248V5.71871Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5248 13.3312H7.6123V34.2812H9.5248V13.3312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.375 11.4312V9.51871H30.475V5.71871H28.575V9.51871H20.95V7.61871H19.05V9.51871H7.6125V7.61871H5.7125V9.51871H3.8125V11.4312H32.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4744 9.51871V5.71871H28.5744V9.51871H20.9494V7.61871H19.0494V9.51871H7.61191V7.61871H5.71191V9.51871H30.4744Z",
    fill: "#FBC04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81289 34.2812H1.90039V36.1937H3.81289V34.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81289 11.4312H1.90039V13.3312H3.81289V11.4312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9 13.3312H0V34.2812H1.9V13.3312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1037_22864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBig);
export default __webpack_public_path__ + "static/media/walletBig.af78143eb94875bc255d7db1187188a3.svg";
export { ForwardRef as ReactComponent };